import React, { useState } from 'react';
import { Outlet, useSearchParams } from 'react-router-dom';
import AdminSidebar from '../components/AdminSidebar';
import AddTenantModal from '../components/AddTenantModal';
import './styles.css';

// No topbar any more — "+ Tilføj tenant" and "+ Opret organisation" now sit
// inline next to each page's own heading (Tenants.jsx / Organizations.jsx),
// and the user menu moved into AdminSidebar's bottom avatar, matching the
// approved navigation redesign.
export default function AdminLayout() {
  const [searchParams] = useSearchParams();
  const orgId = searchParams.get('org');
  // "+ Tilføj tenant" and "+ Opret organisation" both open a modal owned by
  // this layout rather than navigating to a separate page — handed down via
  // outlet context so a child route's own heading-row button can trigger
  // the same modal (Tenants' empty-state CTA already relied on this).
  const [addOrgOpen, setAddOrgOpen] = useState(false);
  const [addTenantOpen, setAddTenantOpen] = useState(false);

  return (
    <div className="nc-shell">
      <AdminSidebar />
      <div className="nc-main">
        <div className="nc-content nc-content--portal">
          <Outlet context={{ addOrgOpen, setAddOrgOpen, addTenantOpen, setAddTenantOpen }} />
        </div>
      </div>
      <AddTenantModal open={addTenantOpen} onClose={() => setAddTenantOpen(false)} orgId={orgId} />
    </div>
  );
}
